define.alias("shared/components/shared/schedule-navbar/notification", "preview-grid/components/shared/schedule-navbar/notification");